import { useParams } from "react-router-dom";
import stl from "./YearsSelectedTags.module.css";
import YearTag from "./YearTag/YearTag";
import useHelpers from "@hooks/useHelpers";

const YearsSelectedTags = ({ tags, className }) => {
  const {year } = useParams();
  const {createUrl} = useHelpers();

  const createTagUrl = (tag) => {
    if (tag.filterField === "make_id")
      return createUrl(`/years/${year}`);

    return createUrl(`/years`); // !! should be changed to /autos/${make} ???
  };

  return (
    <div className={`${stl.wrapper} ${className || ""}`}>
      <div>
        {tags.map((tag, i) => {
          return (
            <YearTag
              key={i}
              title={tag.type === "range" ? tag.range_values.from : tag.name}
              url={createTagUrl(tag)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default YearsSelectedTags;
